import axios from 'axios';
import { toast } from 'react-toastify';
import CustomToast from '../Component/CustomToast/CustomToast';

export const handleIsOpenForm = async (id, token) => {
  try {
    const response = await axios.get(
      `https://formmaker-api.altynlogistics.com/api/form/${id}/is-open`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const output = response.data.output;

    if (!output.open) {
      response.data.errors?.forEach(item =>
        toast(<CustomToast message={item} state="not" />)
      );
      return { isOpen: false };
    }

    if (output.requiresPassword) {
      toast(<CustomToast message="Password is required to open this form" state="not" />);
      return { isOpen: false, requiresPassword: true };
    }

    return { isOpen: true }; 
  } catch (error) {
    console.error('Error checking form status:', error);
    toast(<CustomToast message="خطا در بررسی وضعیت فرم" state="not" />);
    return { isOpen: false };
  }
};
